// extracted by mini-css-extract-plugin
export default {"button":"sign_in_as_action___button___b10e4cee"};